export default __webpack_public_path__ + "static/media/Vambraces of the Milites Templi.ab84cb95.jpg";